import gql from "graphql-tag";
import fetch from "node-fetch";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

const GQLAddCityImage = gql`
  mutation addCityImage(
    $imageurl: String
    $cityname: String
    $statename: String
    $user_id: String
    $caption: String
    $photocategory: String
    $date: String
    $username: String
    $userrole: String
    $userimage: String
  ) {
    addCityImage(
      imageurl: $imageurl
      cityname: $cityname
      statename: $statename
      user_id: $user_id
      caption: $caption
      photocategory: $photocategory
      date: $date
      username: $username
      userrole: $userrole
      userimage: $userimage
    ) {
      success
      message
    }
  }
`;

const QUERY_getcityimage = gql`
  query getcityimage(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getcityimage(
      start: $start
      limit: $limit
      order: $order
      orderBy: $orderBy
      fields: $fields
    ) {
      id
      cityname
      statename
      imageurl
      img_id
      user_id
      caption
      photocategory
      date
      username
      userrole
      rate
      userimage
      imagehelpfulcount
      helpStatus
    }
  }
`;

const GQL_UpdatecityImage = gql`
  mutation UpdatecityImage($id: String, $caption: String) {
    UpdatecityImage(id: $id, caption: $caption) {
      success
      message
    }
  }
`;

const GQL_deleteCityImage = gql`
  mutation deleteCityImage($id: String) {
    deleteCityImage(id: $id) {
      success
      message
    }
  }
`;

const GQL_UpdateCityRate = gql`
  mutation UpdatecityRate($id: String, $rate: Int) {
    UpdatecityRate(id: $id, rate: $rate) {
      success
      message
    }
  }
`;

const GQLHelpCityImageReviews = gql`
  mutation helpcityimagesreviews(
    $reviewId: String
    $cityname: String
    $userId: String
    $helpStatus: Int
    $helpedDate: String
    $updatedDate: String
  ) {
    helpcityimagesreviews(
      reviewId: $reviewId
      cityname: $cityname
      userId: $userId
      helpStatus: $helpStatus
      helpedDate: $helpedDate
      updatedDate: $updatedDate
    ) {
      success
      message
    }
  }
`;

async function UpdateCityrate(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQL_UpdateCityRate,
        variables: {
          id: updatedata.id,
          rate: updatedata.rate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function UpdateCityImage(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQL_UpdatecityImage,

        variables: {
          id: updatedata.id,
          caption: updatedata.caption,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function DeleteCityImage(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQL_deleteCityImage,
        variables: {
          id: deletedataId.id,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function addCityImage(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddCityImage,

        variables: {
          imageurl: adddata.imageurl,
          cityname: adddata.cityname,
          statename: adddata.statename,
          user_id: adddata.user_id,
          caption: adddata.caption,
          photocategory: adddata.photocategory,
          date: adddata.date,
          username: adddata.username,
          userrole: adddata.userrole,
          userimage: adddata.userimage,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getcityimages(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getcityimage,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function helpcityimagesreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLHelpCityImageReviews,
        variables: {
          reviewId: adddata.reviewId,
          cityname: adddata.cityname,
          userId: adddata.userId,
          helpStatus: adddata.helpStatus,
          helpedDate: adddata.helpedDate,
          updatedDate: adddata.updatedDate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export {
  addCityImage,
  getcityimages,
  UpdateCityImage,
  DeleteCityImage,
  UpdateCityrate,
  helpcityimagesreview,
};
